module.exports = __webpack_public_path__ + "media/images/companyPage/passion-5ce01212e1ffa29af6a379b6b2807720.svg";